import { render } from "./bg.vue?vue&type=template&id=645ba66e"
import script from "./bg.vue?vue&type=script&lang=js"
export * from "./bg.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__